// Small notification that appears on the top of the page while the app is scraping
// Cleaned on 9/6

import React, { useContext } from 'react';
import { ApplicationTrackerContext } from '../../contexts/ApplicationTrackerContext';

const LoadingScrapingBanner = () => {
  const { progress } = useContext(ApplicationTrackerContext);
  return (
    <div className="">
      <div className="max-w-340 px-4 pt-4 sm:px-6 lg:px-8 mx-auto text-center">
        <a className="group inline-block bg-blue-600 border border-white/10 p-1 ps-4 rounded-full shadow-md inline-flex items-center">
          <span
            className="animate-spin inline-block size-4 mr-2 border-[3px] border-current border-t-transparent text-white rounded-full"
            role="status"
            aria-label="loading"
          >
            <span className="sr-only">Loading...</span>
          </span>
          <p className="me-2 pb-0 inline-block text-white text-base">
            {<p className="">Updating applications, {Math.floor(progress * 100)}% done...</p>}
          </p>
        </a>
      </div>
    </div>
  );
};

export default LoadingScrapingBanner;
